var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "d-block d-lg-none" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 mb-3" }, [
          _c("h1", { staticClass: "mb-0" }, [_vm._t("default")], 2)
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-6 mb-3" }, [
          _vm.showDeadline
            ? _c("b", [
                _c("span", [
                  _vm._v(_vm._s(_vm._f("toUpperCase")(_vm.$t("Deadline"))))
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm._f("formatDate")(_vm.deadline)))])
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 right" }, [
          _vm.skiplink
            ? _c(
                "a",
                {
                  staticClass: "sr-only sr-only-focusable d-inline",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.skip()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.skiplink))]
              )
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-none d-lg-block" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-9 mb-3" }, [
          _c(
            "h1",
            { staticClass: "d-inline-block mb-0" },
            [_vm._t("default")],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-3 mt-3 right" }, [
          _vm.showDeadline
            ? _c("b", [
                _c("span", [
                  _vm._v(_vm._s(_vm._f("toUpperCase")(_vm.$t("Deadline"))))
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm._f("formatDate")(_vm.deadline)))])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 right" }, [
          _vm.skiplink
            ? _c(
                "a",
                {
                  staticClass: "sr-only sr-only-focusable d-inline",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.skip()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.skiplink))]
              )
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }